import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const putParent = ({ id, ...data }) => {
  return api.put(`admin/parent/${id}`, data);
};

export const usePutParentMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: putParent,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
}; 